// removed by extract-text-webpack-plugin
module.exports = {"root":"clip-search-results__root","clearButton":"clip-search-results__clearButton","closeIcon":"clip-search-results__closeIcon","query":"clip-search-results__query"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/show-page/components/clip-search-results/styles.less
 ** module id = 436
 ** module chunks = 1
 **/